import { KastWebSdkClient } from '@kalyzee/kast-web-sdk';
import { getApiBaseUrl, getUserSocketUrl } from './api';


export const sdkClient = new KastWebSdkClient(
  {
    http: {
      baseUrl: getApiBaseUrl(),
    },
    websocket: {
      baseUrl: getUserSocketUrl(),
      retryAmount: 5,
      retryDelay: 5000,
    }
  }
);

const httpClient = sdkClient.getHttpClient();
const websocketClient = sdkClient.getWebsocketClient();

export {
  httpClient,
  websocketClient
}